/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from 'react';
import {Paper, CircularProgress } from 'material-ui';
import {lightBlue50} from 'material-ui/styles/colors';
import {connect} from "react-redux";

class WindowsStatus extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {statusModel} = this.props;

        return (
            <Paper className="dashboard-page" zDepth={1}>
                <div>Windows: <span className="dashboard-status">{statusModel.RunningStatus}</span><span
                    className="dashboard-up-time">{statusModel.Uptime}</span></div>

                <div style={{position: "relative"}} className="round-progress">
                    <CircularProgress mode="determinate" value={100} size={100} thickness={5} color={lightBlue50} style={{position: "absolute"}}/>
                    <CircularProgress mode="determinate" value={statusModel.CpuUsage} size={100} thickness={5}/>
                    <div className="progress-text">CPU:<br/>{statusModel.CpuUsage.toFixed(0)}%</div>
                </div>

                <div style={{position: "relative"}} className="round-progress">
                    <CircularProgress mode="determinate" value={100}  size={100} thickness={5} color={lightBlue50} style={{position: "absolute"}}/>
                    <CircularProgress mode="determinate" value={statusModel.MemoryUsage} size={100} thickness={5}/>
                    <div className="progress-text">MEM:<br/>{statusModel.MemoryUsage.toFixed(0)}%</div>
                </div>

                <div className="dashboard-summary">
                    <span>Sent: {statusModel.Sent}</span>
                    <span>Pending: {statusModel.Pending}</span>
                    <span>Group: {statusModel.Group}</span>
                    <span>Aquis: {statusModel.Aquis}</span>
                </div>

            </Paper>
        );
    }
}

const mapStateToProps = state => ({
    upTime: state.dashboard.windowsServerStatus ? state.dashboard.windowsServerStatus.Uptime : '',
    statusModel: state.dashboard.windowsServerStatus || {
        MemoryUsage: 0,
        CpuUsage: 0,
        LinuxCpuUsage: 0,
        LinuxMemoryUsage: 0,
        Group: 0,
        Sent: 0,
        Pending: 0,
        Aquis: 0,
        RunningStatus: '',
        LinuxRunningStatus: '',
        Uptime: ''
    }
});

WindowsStatus = connect(mapStateToProps)(WindowsStatus);

export default WindowsStatus;